if (!customElements.get("klaviyo-signup-form")) {
  customElements.define(
    "klaviyo-signup-form",
    class KlaviyoSignupForm extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector("[data-klaviyo-signup-form]");
        this.successMessage = this.querySelector("[data-klaviyo-signup-success]");
        this.errorMessage = this.querySelector("[data-klaviyo-signup-error]");
        this.onSubmit = this.onSubmit.bind(this);
        this.form.addEventListener("submit", this.onSubmit);
      }

      disconnectedCallback() {
        this.form.removeEventListener("submit", this.onSubmit);
      }

      toggleMessage(isSuccess) {
        this.successMessage.hidden = !isSuccess;
        this.errorMessage.hidden = isSuccess;
        this.form.hidden = isSuccess;
        this.form.reset();
      }

      async onSubmit(event) {
        event.preventDefault();
        const email = this.form.email.value.trim();
        if (!email) return;

        try {
          const response = await fetch("https://a.klaviyo.com/client/subscriptions?company_id=WNbFKg", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              REVISION: "2025-07-15",
            },
            body: JSON.stringify({
              data: {
                type: "subscription",
                attributes: {
                  profile: {
                    data: {
                      type: "profile",
                      attributes: {
                        email,
                        locale: this.dataset.locale,
                      },
                    },
                  },
                },
                relationships: { list: { data: { type: "list", id: this.dataset.listId } } },
              },
            }),
          });
          this.toggleMessage(response.ok);
        } catch (error) {
          console.error(error);
          this.toggleMessage(false);
        }
      }
    },
  );
}
